import React from 'react';
import { useState } from 'react';
import Div from '../Div';

const accordionData = [
  {
    question: 'What services does ACE offer?',
    answer:
        'ACE specializes in automating workflows, building responsive websites, and implementing AI-driven solutions to help businesses grow.',
  },
  {
    question: 'Can you customize services for my business needs?',
    answer:
        'Absolutely! We tailor our services to meet the unique requirements of your business, ensuring you get the best results.',
  },
  {
    question: 'Do you offer discounts for yearly payments?',
    answer:
        'Yes! When you choose a yearly payment plan, you get one month free.',
  },
  {
    question: 'Are there any hidden charges?',
    answer:
        'No, our pricing is transparent. You’ll only pay what’s outlined in your chosen plan.',
  },
  {
    question: 'How long does it take to complete a project?',
    answer:
        'The timeline depends on the complexity of your project, but most projects are completed within 4–6 weeks.',
  },
  {
    question: 'Will I have input during the project?',
    answer:
        'Yes, we involve you throughout the process to ensure the final product meets your expectations.',
  },
  {
    question: 'Do you provide documentation for the services?',
    answer:
        'Yes, we provide comprehensive documentation and guides for all our services to help you get started.',
  },
  {
    question: 'Is technical support included?',
    answer:
        'Yes, we offer ongoing technical support for all our clients to ensure everything runs smoothly.',
  },
];

export default function Accordion() {
  const [selected, setSelected] = useState(0);

  const handelToggle = index => {
    if (selected === index) {
      return setSelected(null);
    }
    setSelected(index);
  };

  return (
      <Div className="cs-accordians cs-style1">
        {accordionData.map((item, index) => (
            <Div
                className={`cs-accordian ${selected === index ? 'active' : ''}`}
                key={index}
            >
              <Div
                  className="cs-accordian_head"
                  onClick={() => handelToggle(index)}
              >
                <h2 className="cs-accordian_title">{item.question}</h2>
                <span className="cs-accordian_toggle cs-accent_color">
              <svg
                  width={15}
                  height={8}
                  viewBox="0 0 15 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M0 0L7.5 7.5L15 0H0Z" fill="currentColor" />
              </svg>
            </span>
              </Div>
              <Div className="cs-accordian_body">
                <Div className="cs-accordian_body_in">{item.answer}</Div>
              </Div>
            </Div>
        ))}
      </Div>
  );
}
